export const ON_SELECTED_PRIMARY_CHART_CHANGE = "ON_SELECTED_PRIMARY_CHART_CHANGE";
export const ON_SELECTED_COMPARISON_CHART_CHANGE = "ON_SELECTED_COMPARISON_CHART_CHANGE";
export const ON_SELECTED_CHART_LAYER_CHANGE = "ON_SELECTED_CHART_LAYER_CHANGE";
export const ON_VIEW_CHART_CLICK = "ON_VIEW_CHART_CLICK";



// WEBPACK FOOTER //
// ./src/store/analytics/chart-header/actions.js